module.exports = __webpack_public_path__ + "static/media/pc-side-area-progress.e5331dba.jpg";